import { Typography } from "@mui/material";

export const TopicDescription = ({ text }: { text: string }) => {
  if (!text) return null;
  return (
    <Typography
      sx={{
        color: "#1F2932",
        fontSize: "22px",
        fontWeight: 400,
        lineHeight: "28px",
      }}
    >
      {text}
    </Typography>
  );
};
